import styled from "styled-components";

export const Logo = styled.img`
	margin: 20px 20px 0 20px;
`;

export const MainLogo = styled.img`
	margin: 0 20px 30px 20px;
	width: 140px;
`;

export const HeaderLogo = styled.img`
	margin: 0 20px 0 20px;
	width: 120px;
`;

export const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 10px;
`;

export const MainImg = styled.img`
	max-width: 100%;
	max-height: 100%;
`;
